import {
  FETCH_DRIVERS_DATA,
  FETCH_DRIVERS_SUCCESS,
  FETCH_DRIVERS_FAILURE,
  FETCH_DRIVERS_DETAILS_DATA,
  FETCH_DRIVERS_DETAILS_SUCCESS,
  FETCH_DRIVERS_DETAILS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  details: {
    loading: false,
    data: null,
    error: null,
  },
};

const drivers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DRIVERS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_DRIVERS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_DRIVERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_DRIVERS_DETAILS_DATA:
          return { ...state, details: { loading: true, data: null, error: null } };
        case FETCH_DRIVERS_DETAILS_SUCCESS:
          return { ...state, details: { loading: false, data: action.payload, error: null } };
        case FETCH_DRIVERS_DETAILS_FAILURE:
          return { ...state, details: { loading: false, data: null, error: action.payload } };
    default:
      return state;
  }
};

export default drivers;
